import { getElement } from '../utils/functional';
import { debounce } from '../utils';
import { Module } from './module/module';

// eslint-disable-next-line import/no-default-export
export default class extends Module {
  constructor() {
    super(...arguments);
    this.isTicking = false;
    this.lastKnownY = window.scrollY;
    this.offsetTrackedY = 0;
    this.scrollOffset = 100;
    this.safeZone = 50;
    this.scrollDirection = '';
  }
  initialize() {
    super.initialize();
    this.requestTick = this.requestTick.bind(this);
    this.updateEl = this.updateEl.bind(this);
    this.updateEl();
    this.setHeight();
  }
  setupListeners() {
    super.setupListeners();
    this.debouncedOnResize = debounce(event => {
      this.setHeight();
    }, 250);
    this.listeners.add(window, 'resize', this.debouncedOnResize.bind(this));
    this.onScroll = this.onScroll.bind(this);
    this.listeners.add(window, 'scroll', this.onScroll);
  }
  onScroll() {
    const previouslyKnown = this.lastKnownY;
    const previousDirection = this.scrollDirection;
    this.lastKnownY = window.scrollY;
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up';
    if (previousDirection !== this.scrollDirection) {
      this.offsetTrackedY = this.lastKnownY;
    }
    this.requestTick();
  }
  requestTick() {
    if (!this.isTicking) requestAnimationFrame(this.updateEl);
    this.isTicking = true;
  }
  updateEl() {
    this.isTicking = false;
    this.setSize();
    this.setVisibility();
  }
  setSize() {
    this.element.classList.toggle(this.data.get('sizeClass'), this.headerIsSmaller);
  }
  setVisibility() {
    this.element.classList.toggle(this.data.get('hiddenClass'), !this.shouldBeVisible);
  }
  setHeight() {
    document.body.style.setProperty('--FullHeader_Height', `${this.headerHeight}px`);
  }
  get headerHeight() {
    return getElement('.hd-Banner', {
      context: document.body
    }).getBoundingClientRect().height;
  }
  get shouldBeVisible() {
    if (this.lastKnownY <= this.containerEl.offsetHeight + this.safeZone * 2) {
      return true;
    }
    if (this.scrollDirection === 'down') {
      return !this.isOverOffset;
    } else if (this.scrollDirection === 'up') {
      return this.isOverOffset;
    }
  }
  get isOverOffset() {
    if (this.scrollDirection === 'down') {
      return this.lastKnownY >= this.offsetTrackedY + this.scrollOffset;
    } else if (this.scrollDirection === 'up') {
      return this.lastKnownY <= this.offsetTrackedY - this.scrollOffset;
    }
  }
  get headerIsSmaller() {
    return this.lastKnownY > this.safeZone;
  }
  get containerEl() {
    return this.element.closest('[data-header-container-el]');
  }
}